import React, { FC, memo } from "react";
import Img, { ImagePlaceholderType } from "@/components/img";

type BannerImageComponentProps = {
  imageURL: string;
  onImageLoad?: () => void;
  imagePlaceholderType?: ImagePlaceholderType;
};

const BannerImageComponent: FC<BannerImageComponentProps> = ({
  imageURL,
  onImageLoad,
  imagePlaceholderType = "SINGLE_BANNER"
}) => (
  <div className="lazy-load-wrapper">
    <Img
      src={imageURL}
      alt="banner"
      className="banner-image"
      imagePlaceholderType={imagePlaceholderType}
      onLoadEnd={onImageLoad}
    />
  </div>
);

export default memo(BannerImageComponent);
